import { render, staticRenderFns } from "./related_handle.vue?vue&type=template&id=09e2720a&scoped=true&"
import script from "./related_handle.vue?vue&type=script&lang=js&"
export * from "./related_handle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2720a",
  null
  
)

export default component.exports